const maxLength = max => value => {
    return value && value.length > max ? `Must be ${max} characters or less` : undefined
    return undefined;
}

export default maxLength;